import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import store from './store'
import App from './App.vue'
import router from './router'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import highchartsMore from 'highcharts/highcharts-more'
import exportingInit from 'highcharts/modules/exporting'
import wordCloud from 'highcharts/modules/wordcloud'
import noDataToDisplay from 'highcharts/modules/no-data-to-display'
import { Auth0Plugin } from '../src/components/auth/index.js'
import vuetify from '@/plugins/vuetify.ts'
import qs from 'qs'

window.location.href = 'https://www.ctcsoftware.com'

// Vue.use(Auth0Plugin, {
//   onRedirectCallback: (appState: any) => {
//     router.push(appState && appState.targetUrl ? appState.targetUrl : window.location.pathname)
//   },
// })

// const appInsights = new ApplicationInsights({
//   config: {
//     instrumentationKey: process.env.VUE_APP_TEST_APPINSIGHTS_KEY,
//     enableAutoRouteTracking: true,
//     autoExceptionInstrumented: true,
//     autoTrackPageVisitTime: true,
//     autoUnhandledPromiseInstrumented: true,
//   },
// })

// appInsights.loadAppInsights()
// appInsights.trackPageView()

// Vue.use(qs)
// Vue.use(Vuex)

// exportingInit(Highcharts)
// highchartsMore(Highcharts)
// wordCloud(Highcharts)
// noDataToDisplay(Highcharts)

// Vue.use(HighchartsVue)

// Vue.config.productionTip = false

// new Vue({
//   vuetify,
//   store,
//   router,
//   render: (h) => h(App),
// }).$mount('#app')
